import { Collapse } from 'antd';

import './Help.scss';

const { Panel } = Collapse;

export const Help = () => {
  return (
    <Collapse defaultActiveKey={['1']} className="booking-help">
      <Panel header="I can’t charge my virtual card" key="1">
        <div className="help-text">
          Make sure the amount entered into your payment terminal (POS) matches
          exactly the amount displayed under the "
          <span className="bold">To charge</span>" field above your virtual
          card.
        </div>
      </Panel>

      <Panel header="A client is asking for a refund" key="2">
        <div className="help-text">
          Please contact Staycation to initiate a customer refund.
          <br />
          <br />
          Once the refund amount has been agreed upon, please process the exact
          amount shown under "<span className="bold">To refund</span>" by
          issuing a credit to the virtual card used for the original booking.
        </div>
      </Panel>
      <Panel header="Others issues" key="3">
        <div className="help-text">Please use the Assistance button.</div>
      </Panel>
    </Collapse>
  );
};
